import React from "react"
import { FormattedMessage } from "react-intl"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { INTEGRATION_KEY } from "../../../state/integration/Constants"
import { OrderDto } from "../../../state/order/Order"
import Proposal from "../../../state/proposal/Proposal"

type OwnProps = {
    object: EventObjectDto
    order: OrderDto
    proposal: Proposal
}

const OrderExportedToPipedriveEvent = (props: OwnProps) => {
    const Url = Integrations.getExternalOrderUrl(props.object)
    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {<FormattedMessage
                        id="order.analytics.events.exported.pipedrive.text"
                        defaultMessage="Order {identifier} was created from Pipedrive deal #{externalId}"
                        values={{
                            identifier: <strong>{props.order.attributes.identifier}</strong>,
                            externalId:  props.object.attributes.externalId,
                        }}
                    />}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(INTEGRATION_KEY.PIPEDRIVE, 100, 50)}
                    </a>
                </div>
                {Url &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="order.analytics.events.exported.pipedrive.open"
                                    defaultMessage="Open deal in Pipedrive"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}


export default OrderExportedToPipedriveEvent


// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-exported-pipedrive.component.tsx